import React from 'react'

const FavoriteActivityLoader = ({ size = 1 }) => {
  const rows = []
  for (let i = 0; i < size; i++) {
    rows.push(
      <div
        key={i}
        className="loader-row"
        style={{
          width: `${i % 2 ? 80 : 100}%`,
          height: 16,
          marginBottom: 12,
        }}
      />
    )
  }
  return (
    <div className="favorite-activity">
      <div className="favorite-activity-header">
        <div className="favorite-activity-header__left-part">
          <div className="favorite-activity-header__text favorite-activity-header__text--activity-name favorite-activity-header__text--no-after">
            <div
              className="loader-row"
              style={{
                width: 114,
                height: 24,
              }}
            />
          </div>
          <div className="favorite-activity-header__text favorite-activity-header__text--protrack-name favorite-activity-header__text--no-after">
            <div
              className="loader-row"
              style={{
                width: 100,
                height: 24,
              }}
            />
          </div>
          <div className="favorite-activity-header__text favorite-activity-header__text--timestamp favorite-activity-header__text--no-after">
            <div
              className="loader-row"
              style={{
                width: 55,
                height: 24,
              }}
            />
          </div>
        </div>
        <div className="favorite-activity-header__right-part">
          <div
            className="loader-row"
            style={{
              width: 24,
              height: 24,
            }}
          />
        </div>
      </div>
      <div className="favorite-activity-content">
        <div
          className="loader-row"
          style={{
            width: 20,
            height: 16,
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
        <div className="favorite-activity-content__text">{rows}</div>
      </div>
      <div className="favorite-activity-footer">
        <div className="favorite-activity-footer__content">
          <div className="favorite-activity-footer__author">
            <div
              className="loader-row"
              style={{
                height: 20,
                width: 90,
              }}
            />
          </div>
          <div className="favorite-activity-footer__control">
            <div
              className="loader-row"
              style={{
                width: 160,
                height: 20,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

FavoriteActivityLoader.displayName = 'FavoriteActivityLoader'

export default FavoriteActivityLoader
